import { render, staticRenderFns } from "./cxReturn.vue?vue&type=template&id=140dd096&scoped=true"
import script from "./cxReturn.vue?vue&type=script&lang=js"
export * from "./cxReturn.vue?vue&type=script&lang=js"
import style0 from "./cxReturn.vue?vue&type=style&index=0&id=140dd096&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "140dd096",
  null
  
)

export default component.exports